import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSearchParams } from 'react-router';
import styled from '@emotion/styled';
import { rio } from '@amzn/rio-design-tokens';
import Masthead from '@amzn/meridian/masthead';
import useTheme from '@amzn/meridian/theme/use-theme';
import Text from '@amzn/meridian/text';
import Row from '@amzn/meridian/row';
import { MarketplaceIds } from 'src/utils/links';
import { PrimeLogo } from './PrimeLogo';
import { AmazonLogo } from './AmazonLogo';
import { colors } from 'src/utils/colors';
import { useHeader } from 'src/common/header/HeaderContext';
// Map marketplace IDs to their corresponding domains
const MarketplaceToTopLevelDomain = {
    [MarketplaceIds.CA]: '.ca',
    [MarketplaceIds.ES]: '.es',
    [MarketplaceIds.FR]: '.fr',
    [MarketplaceIds.IT]: '.it',
    [MarketplaceIds.DE]: '.de',
    [MarketplaceIds.UK]: '.co.uk',
};
const AmazonLogoMarketplaceText = styled(Text) `
  margin-top: -8px !important;
  margin-left: 1px !important;
  color: #fff;
`;
const PrimeLogoMarketplaceText = styled(Text) `
  margin-top: 15px !important;
  color: ${({ theme }) => (theme.mode === 'dark' ? colors.primeBlue : rio.semantic.color.font.light)};
`;
// Header is overriden to match Painter 1.0. The default height is 48px which pushes
// page info lower, which could have impact on metrics during migration. Overriding this
// to match 1.0.
const MastheadWrapper = styled.div `
  & > header {
    min-height: 40px;
    height: 40px;
    border-bottom: none;
  }
`;
const StyledRow = styled(Row) `
  position: absolute;
  right: 0;
`;
/**
 * Header for the application.
 */
export const Header = () => {
    const [searchParams] = useSearchParams();
    const theme = useTheme();
    const darkMode = theme.mode === 'dark';
    const { isPrime } = useHeader();
    // Determine styles for prime vs non-prime and light vs dark mode
    const backgroundColorLightMode = isPrime ? colors.primeBlue : colors.headerFooterLightMode;
    const backgroundColor = darkMode ? colors.headerFooterDarkMode : backgroundColorLightMode;
    const marketplaceId = searchParams.get('marketplaceId') || MarketplaceIds.US;
    const topLevelDomain = MarketplaceToTopLevelDomain[marketplaceId];
    const logoMarketplaceText = isPrime ? (_jsx(PrimeLogoMarketplaceText, { type: "b100", darkMode: darkMode, "data-testid": "logo-marketplace-text", children: marketplaceId })) : (_jsx(AmazonLogoMarketplaceText, { type: "b300", "data-testid": "logo-marketplace-text", children: topLevelDomain }));
    return (_jsx(MastheadWrapper, { children: _jsx(Masthead, { backgroundColor: backgroundColor, "data-testid": "header", children: _jsxs(StyledRow, { width: "100%", alignmentHorizontal: "center", spacing: "none", children: [isPrime ? _jsx(PrimeLogo, {}) : _jsx(AmazonLogo, {}), marketplaceId !== MarketplaceIds.US && logoMarketplaceText] }) }) }));
};
